import Observable from "./observable";
import PavementImageType from "./pavementImageType";

export default class Settings {
  public idSettings: number = 0;
  public idUser: number = 0;

  // persisted

  public showChainage: boolean = false;
  public showChainageUnit: boolean = false;
  public playbackSpeed: number = 100;
  public showPavementDistress: boolean = false;
  public showPavementDistressBoxes: boolean = false;
  public showPavementDistressLabels: boolean = false;
  public showPavementLaneMarkings: boolean = false;
  public showPavementEvents: boolean = false;
  public showPavementMarkingsDuringPlayback: boolean = false;
  public pavementImageType: PavementImageType | null = null;

  public onShowChainageChanged: any;
  public onShowChainageUnitChanged: any;
  public onShowPavementDistressChanged: any;
  public onShowPavementDistressBoxesChanged: any;
  public onShowPavementDistressLabelsChanged: any;
  public onShowPavementLaneMarkingsChanged: any;
  public onShowPavementEventsChanged: any;
  public onShowPavementMarkingsDuringPlaybackChanged: any;

  public onSettingsChanged: any;

  // ui

  public showCameraImageUrl: boolean = false;
  public showTableHelperColumns: boolean = false;
  public isChainageInMeters: boolean = false;
  public enableChartsUnitsOnX: boolean = true;

  public showCameraImageUrlObservable: Observable<boolean> =
    new Observable<boolean>();
  public onShowTableHelperColumnsChanged: any;
  public onIsChainageInMetersChanged: any;
  public enableChartsUnitsOnXObservable: Observable<boolean> =
    new Observable<boolean>();

  public init() {
    this.showCameraImageUrlObservable = new Observable<boolean>();
    this.enableChartsUnitsOnXObservable = new Observable<boolean>();
  }
}
